import {
  trigger,
  state,
  style,
  transition,
  animate,
  keyframes,
  AnimationTriggerMetadata
} from '@angular/animations';

export const chatbotAnimations: AnimationTriggerMetadata[] = [
  // Scale animation for chatbot window
  trigger('slideUp', [
    transition(':enter', [
      style({ 
        transform: 'scale(0)',
        opacity: 0,
        'transform-origin': 'bottom right'
      }),
      animate('400ms cubic-bezier(0.32, 1.26, 0.6, 0.96)', 
        style({ 
          transform: 'scale(1)',
          opacity: 1,
          'transform-origin': 'bottom right'
        })
      )
    ]),
    transition(':leave', [
      style({ 
        'transform-origin': 'bottom right'
      }),
      animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)', 
        style({ 
          transform: 'scale(0)',
          opacity: 0,
          'transform-origin': 'bottom right'
        })
      )
    ])
  ]),

  // Fade in animation for messages
  trigger('fadeIn', [
    transition(':enter', [
      style({ opacity: 0 }),
      animate('200ms ease-out', style({ opacity: 1 }))
    ])
  ]),

  // Pulse animation for typing indicator
  trigger('pulse', [
    transition('* => *', [
      animate('1.4s', keyframes([
        style({ transform: 'scale(1)', opacity: 0.7, offset: 0 }),
        style({ transform: 'scale(1.2)', opacity: 1, offset: 0.5 }),
        style({ transform: 'scale(1)', opacity: 0.7, offset: 1 })
      ]))
    ])
  ]),

  // Slide left/right for view transitions
  trigger('slideView', [
    transition('home => *', [
      style({ opacity: 0 }),
      animate('300ms ease-out', style({ opacity: 1 }))
    ]),
    transition('* => home', [
      animate('300ms ease-out', style({ opacity: 0 }))
    ])
  ]),

  // Scale animation for buttons
  trigger('scaleIn', [
    transition(':enter', [
      style({ 
        transform: 'scale(0.8)',
        opacity: 0 
      }),
      animate('200ms cubic-bezier(0.34, 1.56, 0.64, 1)', 
        style({ 
          transform: 'scale(1)',
          opacity: 1 
        })
      )
    ])
  ]),

  // Bounce animation for chatbot trigger button
  trigger('bounce', [
    state('idle', style({ transform: 'scale(1)' })),
    state('active', style({ transform: 'scale(1.1)' })),
    transition('idle <=> active', animate('200ms ease-in-out'))
  ]),

  // Slide down for dropdown menus
  trigger('slideDown', [
    transition(':enter', [
      style({ 
        height: 0,
        opacity: 0,
        overflow: 'hidden'
      }),
      animate('250ms ease-out', 
        style({ 
          height: '*',
          opacity: 1 
        })
      )
    ]),
    transition(':leave', [
      style({ overflow: 'hidden' }),
      animate('250ms ease-in', 
        style({ 
          height: 0,
          opacity: 0 
        })
      )
    ])
  ]),

  // Fade transition for tab content (views)
  trigger('fadeTransition', [
    transition(':enter', [
      style({ opacity: 0 }),
      animate('300ms ease-in-out', style({ opacity: 1 }))
    ]),
    transition(':leave', [
      animate('300ms ease-in-out', style({ opacity: 0 }))
    ])
  ]),

  // Fade in and out animation for message time
  trigger('fadeInOut', [
    transition(':enter', [
      style({ 
        opacity: 0,
        transform: 'translateY(-5px)'
      }),
      animate('200ms ease-out', 
        style({ 
          opacity: 1,
          transform: 'translateY(0)'
        })
      )
    ]),
    transition(':leave', [
      animate('200ms ease-in', 
        style({ 
          opacity: 0,
          transform: 'translateY(-5px)'
        })
      )
    ])
  ]),

  // Slide out up animation for conversation items when deleted
  trigger('slideOutUp', [
    transition(':enter', [
      style({ 
        opacity: 0,
        transform: 'translateY(20px)'
      }),
      animate('250ms ease-out', 
        style({ 
          opacity: 1,
          transform: 'translateY(0)'
        })
      )
    ]),
    transition(':leave', [
      animate('250ms ease-in', 
        style({ 
          opacity: 0,
          transform: 'translateY(-20px)',
          height: 0,
          marginTop: 0,
          marginBottom: 0,
          overflow: 'hidden'
        })
      )
    ])
  ])
];
